import Avatar from "@components/ui-components/avatar";
import { ComponentSpinner } from "@components/spinner";
import Flex from "@components/ui-components/flex";
import { FormFeedback } from "reactstrap";
import { getStatusBadge } from "@src/utility/helpers/utils";
import { useRef } from "react";

const UploadImage = props => {
    const {
        image,
        handleImageSelect,
        disabled,
        avatarProps,
        // showRemove,
        errors,
        loading
    } = props;

    const imageInputRef = useRef();

    return (
        <>
            <Flex
                justify="center"
                className="w-100 mt-2 image-upload position-relative">
                {loading ? <ComponentSpinner/> : <Avatar
                    img={image || false}
                    size={"xl"}
                    onClick={() => {
                        if (image || disabled) {
                            return;
                        }
                        // @ts-ignore
                        imageInputRef?.current?.click();
                    }}
                    content={avatarProps.name}
                    disabled={disabled}
                    color={getStatusBadge(avatarProps.status).color}
                    initials
                    rounded/>}
                <input
                    ref={imageInputRef}
                    onChange={handleImageSelect}
                    multiple={false}
                    disabled={disabled}
                    type="file"
                    accept="image/svg, image/jpeg, image/png"
                    hidden/>
                {/* {image && !disabled && showRemove ? (
                    <span
                        className="image-remove"
                        onClick={() => handleImageSelect("")}>
                        <i className="mdi mdi-delete" />
                    </span>
                ) : null} */}
                {!disabled ? (
                    <span
                        className="image-upload"
                        // @ts-ignore
                        onClick={() => imageInputRef?.current?.click()}>
                        <i className="mdi mdi-pencil" />
                    </span>
                ) : null}
            </Flex>
            {errors && "image" in errors ? (
                <FormFeedback className="text-danger text-center w-100 d-flex justify-content-center mt-1">
                    {errors.image?.message?.toString()}
                </FormFeedback>
            ) : null}
        </>
    );
};
export default UploadImage;
